import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import { CommunityGuard } from '@src/components/guard/CommunityGuard';
import { useSharedAuth } from '@src/context/auth/useSharedAuth';
import CommunityChatForm from '@src/features/shared/community/CommunityChatForm';
import CommunityDefaultLayout from '@src/layouts/shared/CommunityDefaultLayout';
import { useState } from 'react';

function Community() {
  const sharedAuth = useSharedAuth();
  const profile = sharedAuth.profile?.isTenant
    ? sharedAuth.profile?.tenantProfile
    : sharedAuth.profile?.companyProfile;

  const [feature, setFeature] = useState('');

  return (
    <CommunityGuard
      profile={profile}
      isTenant={sharedAuth.profile?.isTenant ?? false}
      canService={[SERVICE.ONLINE_COMMUNITY]}
      checkAuthenticate={false}
      checkAccessibleNotPublicChannel={false}
    >
      <CommunityDefaultLayout>
        <CommonHelmet feature={feature} />
        <CommunityChatForm setFeature={setFeature} />
      </CommunityDefaultLayout>
    </CommunityGuard>
  );
}

export default Community;
